/*
 * Copyright (C) 2020 Bosch.IO GmbH. All rights reserved.
 */

import React from 'react';
import styled from 'styled-components';
import { Icon } from '../../atoms';

// TODO after release of FROK 1.1 check if "a-button--integrated" is available

const StyledBladeActionButton = styled.button`
    color: var(--integrated__enabled__front__default);
    background-color: var(--integrated__enabled__fill__default);
    &:hover {
        color: var(--integrated__enabled__front__hovered);
        background-color: var(--integrated__enabled__fill__hovered);
    }
    &:active {
        color: var(--integrated__enabled__front__pressed);
        background-color: var(--integrated__enabled__fill__pressed);
    }
`;

export const BladeActionButton: React.FC<{
    title: string;
    icon: string;
    onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}> = ({ title, icon, onClick }) => (
    <StyledBladeActionButton
        title={title}
        className={'a-button'}
        onClick={onClick}
    >
        <Icon iconName={icon} />
    </StyledBladeActionButton>
);
